import { useLanguageContext } from "../../../../context/LanguageContext";
import PaxtonConfigsPage from "../../../../pages/integrations/paxton/PaxtonConfigsPage";
import { usePaxtonConfigsRouteValidator } from "../../../validators/integrations/paxton/PaxtonConfigsRouteValidator";
import { RouteConfig } from "../../RouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function usePaxtonConfigsRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/integrations/paxton")
    .setLabel(translate("eva.main.entities.paxton_config"))
    .setValidator(usePaxtonConfigsRouteValidator())
    .setPage(<PaxtonConfigsPage />);
}

export default usePaxtonConfigsRouteConfig;
